import {mapActions, mapGetters, mapMutations} from "vuex";
import 'flatpickr/dist/flatpickr.css';
import {camelCase} from "lodash";
import VueFlatPickr from 'vue-flatpickr-component';
import {Russian} from "flatpickr/dist/l10n/ru.js"
import {Ukrainian} from "flatpickr/dist/l10n/uk.js"
import {English} from "flatpickr/dist/l10n/default.js"
import {Indonesian} from "flatpickr/dist/l10n/id.js"
import HeadFilter from '@/components/features/head-filter/index.vue';
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'

import activeItemHomework from '../../components/active-item-homework/index.vue'
import MainSelect from '@/components/atoms/main-select/index.vue'
import store from '@/store/'
import {seo} from '@/mixins/seo'

export default {
    name: 'profile-homework',
    mixins: [seo],
    data() {
        return {
            payload: {
                dateFrom: '',
                dateTo: '',
                status: {id: '', name: this.$t('together')},
                course: {id: '', name: this.$t('together')},
            },
            homeWorkStatusList: [],
            homeWorkCoursesList: [],
            config: {
                altFormat: "j M, Y",
                altInput: true,
                start: {
                    minDate: null,
                    maxDate: null,
                    disableMobile: "true",
                    "locale": this.getCalendarLang(),
                },
                end: {
                    minDate: null,
                    disableMobile: "true",
                    "locale": this.getCalendarLang(),
                },
            }
        }
    },
    components: {
        activeItemHomework,
        HeadFilter,
        'date-picker': VueFlatPickr,
        BtnLoadMore,
        MainSelect
    },
    computed: {
        ...mapGetters({
            list: 'userHomework/list',
            listLength: 'userHomework/listLength',
            isListLoading: 'userHomework/isListLoading',

            statusList: 'userHomework/statusList',
            isStatusListLoading: 'userHomework/isStatusListLoading',
        }),
    },
    watch: {
        statusList(newVal) {
            if (newVal) {
                this.homeWorkStatusList = this.statusList.userHomeWorks.statuses;
                for (let i in this.homeWorkStatusList) {
                    this.homeWorkStatusList[i].name = this.$t(this.toCamelCase(this.homeWorkStatusList[i].title))
                }
            }
        },
        list() {
            this.homeWorkCoursesList = [];
            for (let y in this.list) {
                this.homeWorkCoursesList.push(this.list[y].course.data)
            }
        }
    },
    created() {
        this.seo.title = this.$t(camelCase(this.$route.name));
        if (!this.statusList.length) {
            this.fetchStatusList();
        }

        this.fetchList(this.payload);
    },
    methods: {
        ...mapActions({
            fetchList: 'userHomework/GET_LIST',
            fetchStatusList: 'userHomework/GET_STATUS_LIST',
        }),
        ...mapMutations({
            changeSkip: 'userHomework/CHANGE_SKIP',
            setList: 'userHomework/SET_LIST',
            changeCourseFilter: 'userHomework/CHANGE_HOMEWORK_FILTER_COURSE',
            changeStatusFilter: 'userHomework/CHANGE_HOMEWORK_FILTER_STATUS',
            clearHomeWorkFilters: 'userHomework/CLEAR_HOMEWORK_FILTERS',
        }),
        onStartChange(selectedDates, dateStr, instance) {
            this.$set(this.config.end, 'minDate', dateStr);
            this.payload.dateFrom = dateStr;
            this.changeSkip(false)
            this.setList([])
            this.fetchList(this.payload);
        },
        onEndChange(selectedDates, dateStr, instance) {
            this.$set(this.config.start, 'maxDate', dateStr);
            this.payload.dateTo = dateStr;
            this.changeSkip(false)
            this.setList([])
            this.fetchList(this.payload);
        },
        toCamelCase(str) {
            return camelCase(str)
        },
        selectStatus() {
            if (!this.isListLoading) {
                this.changeStatusFilter(this.payload.status.id)
                this.setList([])
                this.fetchList(this.payload);
            }
        },
        selectCourses() {
            if (!this.isListLoading) {
                this.changeCourseFilter(this.payload.course.id)
                this.setList([])
                this.fetchList(this.payload);
            }
        },
        getCalendarLang() {
            const currentLang = store.getters.currentLanguage.translationKey;

            if (currentLang == 'uk') {
                return Ukrainian;
            } else if (currentLang == 'ru') {
                return Russian;
            } else if (currentLang == 'id') {
                return Indonesian;
            } else {
                return English;
            }
        }
    },
    destroyed() {
        this.clearHomeWorkFilters();
    }
}
